<template>
  <div id="prize-modal" class="modal" tabindex="-1" role="dialog" style="top: 50px">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
          <h4 class="modal-title">{{ premio.valorPremio }}</h4>
        </div>
        <div class="modal-body" v-if="loading">
          <div class="content-loader">
            <Loader />
          </div>
        </div>
        <div class="modal-body" style="display: flex; justify-content: center" v-html="premio.premioHtml" v-if="!loading"></div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.content-loader {
  display: flex;
  justify-content: center;
  width: 500px;
  height: 200px;
  align-items: center;
}
.modal {
  padding: 1%;
}
.modal-lg {
  min-width: auto;
  max-width: fit-content;
}
</style>

<script>
import CarrinhoService from '@/services/CarrinhoService'

export default {
  name: 'PrizeModal',
  props: ['codigoPedido'],
  data() {
    return {
      premio: {},
      loading: true,
    }
  },
  methods: {
    async getPremio() {
      try {
        let premio = {
          valorPremio: 'Por favor, aguarde...',
          premioHtml: '',
        }
        this.premio = premio

        this.loading = true
        const result = await CarrinhoService.ComissaoDoPedidoVendaDireta(this.$apiUrl, this.codigoPedido)
        if (result) {
          let comissao = result.split('|')

          premio = {
            valorPremio: `Prêmio: ${comissao[0]}`,
            premioHtml: comissao[1],
          }
          this.premio = premio
          this.loading = false
        }
      } catch (error) {
        console.log(error)
      }
    },
  },
}
</script>
